module.exports = "<div class=\"nbrating\">\n  <i *ngFor=\"let o of full;let idx = index\" class=\"fa\" [ngClass]=\"_shape[o]\" (click)=\"changeData(idx)\"></i>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/nbinput/nbinput-rating.component.html
// module id = 193
// module chunks = 0 1